import DealMenu from '@/components/deal/deal-menu/deal-menu';
import DealFavoriteUnfavorite from '@/components/deal/favorite-unfavorite/deal-favorite-unfavorite';
import { ReactivateButton } from '@/components/deal/reactivate-button';
import AgentConvo from '@/components/sms/agent-convo/agent-convo';
import TextConvo from '@/components/sms/text-convo/text-convo';
import TextRecap from '@/components/sms/text-recap/text-recap';
import { HubDealPageHeader } from '@/components/ui/layout/headers';
import { Tooltip, TooltipContent } from '@/components/ui/tooltip';
import useGoToDeal from '@/hooks/use-go-to-deal';
import { TIMESTAMP_FORMAT } from '@/lib/constants.ts';
import { cn } from '@/lib/utils';
import { Deal } from '@/models/registry';
import { TooltipTrigger } from '@radix-ui/react-tooltip';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { ChevronRight, Circle, CircleCheck } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

dayjs.extend(utc);
dayjs.extend(timezone);

const LastSaved = observer(({ deal }: { deal: Deal }) => {
  const lastSaved = dayjs(deal.last_updated);
  const wasSavedRecently = lastSaved.isAfter(dayjs().subtract(5, 'seconds'));

  // TECH DEBT: make a hook called useTick
  const [, setTime] = useState(dayjs());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(dayjs());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          {wasSavedRecently ? (
            <CircleCheck
              className={cn('h-3.5 w-3.5 cursor-pointer text-green-500', {})}
            />
          ) : (
            <Circle className={cn('h-3.5 w-3.5 cursor-pointer', {})} />
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p>Last saved {lastSaved.format(TIMESTAMP_FORMAT)}</p>
      </TooltipContent>
    </Tooltip>
  );
});

const NonMobileHeader = observer(({ deal }: { deal: Deal }) => {
  const dealShortId = deal.short_id ?? '';
  const { ai_summary, sms_conversation, sms_agent_messages } = deal;

  const { goToDeal } = useGoToDeal();

  return (
    <HubDealPageHeader
      separator={<ChevronRight className={cn('h-5 w-5', {})} />}
      shortIdWrapper={
        <div
          className="pl-1.5 text-nowrap cursor-pointer"
          onClick={() => {
            goToDeal({ dealShortId, isForInbox: false });
          }}
        >
          {dealShortId}
        </div>
      }
      rowLeft={
        <>
          <DealMenu deal={deal} withHokeyListener />
          <DealFavoriteUnfavorite />
          <ReactivateButton />
        </>
      }
      rowRight={
        <div className="flex flex-row items-center gap-3">
          <TextRecap
            aiSummary={ai_summary}
            dealShortId={dealShortId}
            smsConversation={sms_conversation}
          />
          <TextConvo
            smsConversation={sms_conversation}
            dealShortId={dealShortId}
          />
          <AgentConvo smsConversation={sms_agent_messages} />
          <LastSaved deal={deal} />
        </div>
      }
    />
  );
});

export default NonMobileHeader;
